import { coreInstance, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    product_list_pagination: {
      page: 1,
      rowsPerPage: 10
    },
    product_list: [],
    product_detail: null
  },
  mutations: {
    resetState(state) {
      state.product_list_pagination = {
        page: 1,
        rowsPerPage: 10
      };
      state.product_list = [];
      state.product_detail = null;
    },
    dupplicateProduct(state, { index, product_added }) {
      state.product_list.splice(index + 1, 0, product_added);
    },
    setProductListPagination(state, data) {
      state.product_list_pagination = JSON.parse(JSON.stringify(data));
    },
    getData(state, data) {
      let res = data;
      res.sort(function (a, b) {
        let a_series = parseInt(a.product_series);
        let b_series = parseInt(b.product_series);
        if (a_series === b_series) {
          return 0;
        } else if (a_series === null) {
          return 1;
        } else if (b_series === null) {
          return -1;
        } else if (true) {
          return a_series < b_series ? -1 : 1;
        }
      });
      state.product_list = res;
    },
    addProductList(state, data) {
      state.product_list.push(data);
    },
    delProductList(state, data) {
      let index = state.product_list.findIndex(
        val => val.product_id == data.product_id
      );
      state.product_list.splice(index, 1);
    },
    onWebProduct(state, data) {
      let index = state.product_list.findIndex(val => val.product_id == data.product_id);
      state.product_list[index].product_approve = 2;
    },
    getProductDetail(state, data) {
      state.product_detail = data;
    },
    editProduct(state, data) {
      Object.assign(state.product_detail, data);
    },
    addMoreOption(state, res_data) {
      state.product_detail.product_option.push(res_data);
    },
    editCurrentOption(state, send_data) {
      let index = state.product_detail.product_option.indexOf(
        send_data.option_data
      );
      Object.assign(
        state.product_detail.product_option[index],
        send_data.res_data
      );
    }
  },
  actions: {
    async manualGetProductListByProvince({ commit, rootState, dispatch }, configPath) {
      let { storeID, provinceID } = configPath;
      let province = rootState.fetchProvinceBack.provinceData.find(val => val.province_id == provinceID)
      province = province.province_name_en.replace(/\s/g, '').toLowerCase();
      return coreInstance
        .get(
          backendVersion.version +
          "/service/GetServiceDiscovery/" +
          province +
          "/web_back_office"
        )
        .then(async (res) => {
          let url = res.data.fetchProductListBack_getData + storeID;
          let response = await dispatch("fetchGeneral/axiosPathGetData", url, {
            root: true
          });
          if (typeof response == "boolean" && response == false) {
            return false;
          } else {
            return response;
          }
        })
        .catch((err) => { });

    },
    async deActivate({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchProductListBack_deActivate + data.product_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: data.data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async getProductByType({ commit, rootState, dispatch }, product_type) {
      commit("getData", []);
      let url =
        rootState.api_urls.fetchProductListBack_getProductByType + product_type;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getData", res);
        return 2;
      }
    },
    async sortProductList({ commit, rootState, dispatch }, sort_product_list) {
      let url = rootState.api_urls.fetchProductListBack_sortProductList;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: sort_product_list },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        return 2;
      }
    },
    async addEditOption({ commit, rootState, dispatch }, form_data) {
      let url = rootState.api_urls.fetchProductListBack_addEditOption;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: form_data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res;
      }
    },
    async delOption({ commit, rootState, dispatch }, id) {
      let url = rootState.api_urls.fetchProductListBack_delOption + id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async delChoice({ commit, rootState, dispatch }, id) {
      let url = rootState.api_urls.fetchProductListBack_delChoice + id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async editCurrentOption({ commit, dispatch, rootState }, option_data) {
      let url =
        rootState.api_urls.fetchProductListBack_editCurrentOption +
        option_data.option_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: option_data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        let send_data = {
          res_data: res,
          option_data
        };
        commit("editCurrentOption", send_data);
        return true;
      }
    },
    async addMoreOption({ commit, dispatch, rootState }, option_data) {
      let url = rootState.api_urls.fetchProductListBack_addMoreOption;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: option_data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("addMoreOption", res);
        return "No data available";
      }
    },
    async editProduct({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchProductListBack_editProduct + data.product_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async getProductDetail({ commit, rootState, dispatch }, product_id) {
      let url =
        rootState.api_urls.fetchProductListBack_getProductDetail + product_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getProductDetail", res);
        return res;
      }
    },
    async onWebProduct({ commit, rootState, dispatch }, data) {
      let send_data = {
        product_id: data.product_id,
        product_approve: 2
      };
      let url =
        rootState.api_urls.fetchProductListBack_onWebProduct + data.product_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: send_data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("onWebProduct", data);
      }
    },
    async delProductList({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchProductListBack_delProductList +
        data.product_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("delProductList", data);
      }
    },
    async editType({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchProductListBack_editType + data.product_type_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async addProductList({ commit, rootState, dispatch }, data) {
      let url = rootState.api_urls.fetchProductListBack_addProductList;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res;
      }
    },
    async getData({ commit, state, dispatch, rootState }) {
      let url =
        rootState.api_urls.fetchProductListBack_getData +
        rootState.storeBack.store_detail_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getData", res);
      }
    }
  },
  getters: {
    productListTable(state) {
      let product_list = state.product_list
      for (let val of product_list) {
        val.product_name = val.product_name_th + " " + val.product_name_en;
      }
      return product_list;
    }
  }
};
